import React, { useState } from 'react';
import { useLocale } from '../lib/LocaleContext';
import styles from './DataGrid.module.css';

export default function DataGrid({ columns, data, loading, onRefresh, title, headerActions, onRowClick, className, emptyText }) {
  const { t } = useLocale();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    if (!onRefresh) return;
    setIsRefreshing(true);
    try { await onRefresh(); } finally { setIsRefreshing(false); }
  };

  const formatDate = s => { try { return new Date(s).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }); } catch { return s; } };

  const containerClass = [styles.dataGridContainer, className].filter(Boolean).join(' ');
  const emptyMessage = emptyText != null ? emptyText : t.noData;

  return (
    <div className={containerClass}>
      {(title || onRefresh || headerActions) && (
        <div className={styles.dataGridHeader}>
          {title && <h3 className={styles.dataGridTitle}>{title}</h3>}
          <div className={styles.headerActions}>
            {headerActions}
            {onRefresh && (
              <button
                className={styles.refreshButton}
                onClick={handleRefresh}
                disabled={isRefreshing}
              >
                {isRefreshing ? t.refreshing : t.refresh}
              </button>
            )}
          </div>
        </div>
      )}
      <div className={styles.dataGridWrapper}>
        <table className={styles.dataGrid}>
          <thead><tr>{columns.map(c => <th key={c.key} style={{ width: c.width }}>{c.label}</th>)}</tr></thead>
          <tbody>
            {loading && data.length === 0 ? (
              <tr><td colSpan={columns.length} className={styles.loadingCell}><div className={styles.loadingState}><p>{t.loading}</p></div></td></tr>
            ) : data.length === 0 ? (
              <tr><td colSpan={columns.length} className={styles.emptyCell}><div className={styles.emptyState}><p>{emptyMessage}</p></div></td></tr>
            ) : (
              data.map((row, i) => (
                <tr key={row.id ?? i} onClick={onRowClick ? () => onRowClick(row) : undefined}>
                  {columns.map(c => (
                    <td key={c.key}>
                      {c.render ? c.render(row[c.key], row) : (row[c.key] == null ? '-' : (typeof row[c.key] === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(row[c.key]) ? formatDate(row[c.key]) : String(row[c.key])))}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
